import { useMutation, useQueryClient } from "@tanstack/react-query";
import calendarEventApiClient, {
  CalendarEvent,
} from "../../../api/calendarEvent";

export const useUpsertKlydoEvent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      eventId,
      event,
    }: {
      eventId: string;
      event: Partial<CalendarEvent>;
    }) => {
      return calendarEventApiClient.upsertCalendarEvent(eventId, event);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["klydo-events"] });
      queryClient.invalidateQueries({ queryKey: ["calendar-events"] });
      queryClient.invalidateQueries({ queryKey: ["calendar-events-by-date"] });
    },
  });
};

export const useDeleteKlydoEvent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (eventId: string) => {
      return calendarEventApiClient.deleteCalendarEvent(eventId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["klydo-events"] });
      queryClient.invalidateQueries({ queryKey: ["calendar-events"] });
      queryClient.invalidateQueries({ queryKey: ["calendar-events-by-date"] });
    },
  });
};
